/* eslint-disable no-unused-expressions */
import {Tour} from "../Tour";

const listenButtonStep = {
  title: "Mode écoute",
  intro: 'Cliquez sur ce bouton pour activer le mode écoute et permettre au professeur Tokatab de vous faire des retours en fonction des notes que vous jouez.',
  element: '.player-tour__listen-button',
}

const tours = [
  {
    name: "PlayerTour",
    steps: [
      listenButtonStep,
      // {
      //   title: "À vous de jouer !",
      //   intro: "Cliquez sur ce bouton pour lancer le morceau et le jouer en même temps sur votre piano. \n Un décompte vous laissera le temps de placer votre main.",
      //   element: ".player-tour__play",
      //   onStepEnter: () => {
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-keep-basic');
      //     const menuContent: HTMLElement = document.querySelector('.player-freemode-tour-mobile__visibility-and-sound') as HTMLElement;
      //     if (menuContent) {
      //       const menuBtn: HTMLElement = document.querySelector('.player-freemode-tour-mobile__dots-controls') as HTMLElement;
      //       menuBtn.click();
      //     }
      //   }
      // }
    ]
  },

  {
    name: "PlayerFreeModeTour",
    steps: [
      /* Mobile */
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: 'En mobile, ce bouton permet d\'accéder aux outils pour travailler à votre rythme.',
      //   element: '.player-freemode-tour-mobile__dots-controls',
      //   isOnlyMobile: true,
      //   isOnlyDesktop: false,
      // },

      // Disable it for now since q-menu is hidden when clicked outside (making it disapear each time you try to got o the next step)
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: "Ici vous pourrez régler et désactiver les sons et l'affichage des mains, du métronome et des paroles.",
      //   beforeChange: (arr: any[], index: any) => {
      //     arr[index].element = document.querySelector('.player-freemode-tour-mobile__visibility-and-sound')
      //   },
      //   onStepEnter: () => {
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.remove('introjs-keep-basic');
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-mobile-top');
      //   },
      //   isOnlyMobile: true,
      // },
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: "En cliquant ici vous pourrez activer une boucle de la partie sur laquelle vous vous trouvez.",
      //   beforeChange: (arr: any[], index: any) => {
      //     arr[index].element = document.querySelector('.player-freemode-tour-mobile__loop')
      //   },
      //   onStepEnter: () => {
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-mobile-top');
      //   },
      //   isOnlyMobile: true,
      // },
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: "Ici vous gérez la vitesse de lecture, bouton très important pour travailler le morceau en baissant la vitesse !",
      //   beforeChange: (arr: any[], index: any) => {
      //     arr[index].element = document.querySelector('.player-freemode-tour-mobile__speed')
      //   },
      //   onStepEnter: () => {
      //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-mobile-top');
      //   },
      //   onStepLeave: () => {
      //     const menuContent: HTMLElement = document.querySelector('.player-freemode-tour-mobile__visibility-and-sound') as HTMLElement;
      //     if (menuContent) {
      //       const menuBtn: HTMLElement = document.querySelector('.player-freemode-tour-mobile__dots-controls') as HTMLElement;
      //       menuBtn.click();
      //     }
      //   },
      //   isOnlyMobile: true,
      // },
      /* Desktop */
      // {
      //   title: "Travailler à votre rythme en autonomie",
      //   intro: "Ici vous pourrez régler et désactiver les sons et l'affichage des mains, du métronome et des paroles.",
      //   element: ".player-freemode-tour-desktop__visibility-and-sound",
      //   isOnlyDesktop: true,
      // },
      {
        title: "Travailler à votre rythme en autonomie",
        intro: "En cliquant ici vous pourrez activer une boucle de la partie sur laquelle vous vous trouvez.",
        element: ".player-freemode-tour-desktop__loop",
        isOnlyDesktop: true,
      },
      {
        title: "Travailler à votre rythme en autonomie",
        intro: "Ici vous gérez la vitesse de lecture, bouton très important pour travailler le morceau en baissant la vitesse !",
        element: ".player-freemode-tour-desktop__speed",
        isOnlyDesktop: true,
      },
      /* Both */
      {
        title: "Travailler à votre rythme en autonomie",
        intro: "Enfin, ce bouton est très important ! Il vous permet d'activer une assistance d'apprentissage étape par étape du morceau.",
        element: ".player-freemode-tour__help",
      }
    ]
  } as Tour,

  {
    name: "PlayerClassTour",
    steps: [
      {
        title: "Mode cours",
        intro: "Ici Tokatab vous guide étape par étape pour apprendre le morceau !",
      },
      {
        title: "Mode cours",
        intro: "Chaque lettre colorée correspond à une section. C'est un passage musical plus court et facilement mémorisable !",
        element: ".player-class-tour__section",
      },
      {
        title: "Mode cours",
        intro: "Jouer une partie revient à enchaîner toutes ses sections.",
        element: ".player-class-tour__part"
      },
      {
        title: "Mode cours",
        intro: "Souvent des parties différentes ont des sections en commun qu'il suffit d'apprendre une fois.",
        element: ".player-class-tour__all-parts"
      },
      // Disable Sing Step since it is not present in most of our songs
      // {
      //   title: "Mode cours",
      //   intro: "...et à placer le chant dessus.",
      //   element: ".player-class-tour__chant"
      // },
    ]
  },

  {
    name: "PlayerScoreEvolutionTour",
    steps: [
      {
        title: "Les scores",
        intro: "Le score monte de 0 à 100 et indique à quel point ce morceau ou ce challenge sera facile à apprendre pour vous.",
        element: ".tour-score-evolution",
      },
      {
        title: "100% personnalisé",
        intro: "Ce score est 100% personnalisé, et calculé en fonction des techniques que vous avez déjà pratiquées sur Tokatab. Plus vous jouerez de challenges, morceaux et exercices, plus le score augmentera !",
        element: ".tour-score-evolution"
      },
    ]
  },

  {
    name: "ShowParameterTour_tempo",
    steps: [
      {
        title: "Changer le tempo",
        intro: "Ici vous pouvez gérez la vitesse de lecture !",
        element: ".player-freemode-tour-desktop__speed",
      },
    ]
  },

  {
    name: "ShowParameterTour_sound",
    steps: [
      {
        title: "Gérer les volumes",
        intro: "Ici vous pouvez augmenter ou baisser les volumes !",
        element: ".player-tour__volume",
      },
    ]
  },

  {
    name: "ShowParameterTour_MobileDisplayMenu",
    steps: [
      {
        title: "Gérer l'affichage",
        intro: "Ici vous pouvez changer différents paramètres d'affichage !",
        element: ".player-tour__displayMenu",
      },
    ]
  },

  {
    name: "ShowParameterTour_displayFingerOrNotes",
    steps: [
      {
        title: "Affichage des notes ou des doigtés",
        intro: "C'est ici que vous pouvez choisir d'afficher les doigtés ou les notes !",
        element: ".player-tour__displayFingerOrNotes",
      },
    ]
  },

  {
    name: "ShowParameterTour_listenModeButton",
    steps: [listenButtonStep]
  },

  {
    name: "ShowParameterTour_sheetMusicMode",
    steps: [
      {
        title: "Mode piano roll ou partition",
        intro: "En cliquant sur ce bouton vous pouvez choisir entre le mode piano roll ou le monde partition !",
        element: ".player-tour__pianoRollSheetMusic",
      },
    ]
  },

  /* Mobile */
  // {
  //   title: "Travailler à votre rythme en autonomie",
  //   intro: 'En mobile, ce bouton permet d\'accéder aux outils pour travailler à votre rythme.',
  //   element: '.player-freemode-tour-mobile__dots-controls',
  //   onStepEnter: () => {
  //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.add('introjs-keep-basic');
  //     document.querySelector('.introjs-tooltipReferenceLayer')?.classList.remove('introjs-mobile-top');
  //   },
  //   onStepLeave: () => {},
  //   beforeChange: () => {},
  //   isOnlyMobile: true,
  //   isOnlyDesktop: false,
  // },
  /* Desktop */
  // {
  //   title: "Travailler à votre rythme en autonomie",
  //   intro: "Ici vous pourrez régler et désactiver les sons et l'affichage des mains, du métronome et des paroles.",
  //   element: ".player-freemode-tour-desktop__visibility-and-sound",
  //   isOnlyDesktop: true,
  // },
  // {
  //   title: "Travailler à votre rythme en autonomie",
  //   intro: "En cliquant ici vous pourrez activer une boucle de la partie sur laquelle vous vous trouvez.",
  //   element: ".player-freemode-tour-desktop__loop",
  //   isOnlyDesktop: true,
  // },

] as Tour[];

export default {tours};
